import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createDedicatedConfig, updateDedicatedConfig } from "./api";
import { invalidateJobQueries } from "components/job/queries";

export function useCreateDedicatedConfig() {
  return useMutation({
    mutationFn: async ({ jobId, values }) => {
      return await createDedicatedConfig({ jobId, values });
    },
    onSuccess: () => {
      toast.success("Config created successfully");
      invalidateJobQueries();
    },
    onError: (err) => {
      toast.error(err.message || "Failed to create config");
      console.error(err);
    },
  });
}

export function useUpdateDedicatedConfig() {
  return useMutation({
    mutationFn: async ({ id, values }) => {
      return await updateDedicatedConfig({ id, values });
    },
    onSuccess: () => {
      toast.success("Config updated successfully");
      invalidateJobQueries();
    },
    onError: (err) => {
      toast.error(err.message || "Failed to update config");
      console.error(err);
    },
  });
}
